"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "AddHeavy", {
  enumerable: true,
  get: function get() {
    return _AddHeavy.default;
  }
});
Object.defineProperty(exports, "Apple", {
  enumerable: true,
  get: function get() {
    return _Apple.default;
  }
});
Object.defineProperty(exports, "Arrange", {
  enumerable: true,
  get: function get() {
    return _Arrange.default;
  }
});
Object.defineProperty(exports, "ArrowCircleDown", {
  enumerable: true,
  get: function get() {
    return _ArrowCircleDown.default;
  }
});
Object.defineProperty(exports, "ArrowCircleLeft", {
  enumerable: true,
  get: function get() {
    return _ArrowCircleLeft.default;
  }
});
Object.defineProperty(exports, "ArrowCircleRight", {
  enumerable: true,
  get: function get() {
    return _ArrowCircleRight.default;
  }
});
Object.defineProperty(exports, "ArrowCircleSide", {
  enumerable: true,
  get: function get() {
    return _ArrowCircleSide.default;
  }
});
Object.defineProperty(exports, "ArrowCircleUp", {
  enumerable: true,
  get: function get() {
    return _ArrowCircleUp.default;
  }
});
Object.defineProperty(exports, "ArrowDown", {
  enumerable: true,
  get: function get() {
    return _ArrowDown.default;
  }
});
Object.defineProperty(exports, "ArrowLeft", {
  enumerable: true,
  get: function get() {
    return _ArrowLeft.default;
  }
});
Object.defineProperty(exports, "ArrowRight", {
  enumerable: true,
  get: function get() {
    return _ArrowRight.default;
  }
});
Object.defineProperty(exports, "ArrowUp", {
  enumerable: true,
  get: function get() {
    return _ArrowUp.default;
  }
});
Object.defineProperty(exports, "Asterisk", {
  enumerable: true,
  get: function get() {
    return _Asterisk.default;
  }
});
Object.defineProperty(exports, "Ban", {
  enumerable: true,
  get: function get() {
    return _Ban.default;
  }
});
Object.defineProperty(exports, "BellHeavy", {
  enumerable: true,
  get: function get() {
    return _BellHeavy.default;
  }
});
Object.defineProperty(exports, "Bell", {
  enumerable: true,
  get: function get() {
    return _Bell.default;
  }
});
Object.defineProperty(exports, "Bold", {
  enumerable: true,
  get: function get() {
    return _Bold.default;
  }
});
Object.defineProperty(exports, "BookmarkCircleSolid", {
  enumerable: true,
  get: function get() {
    return _BookmarkCircleSolid.default;
  }
});
Object.defineProperty(exports, "BookmarkSolid", {
  enumerable: true,
  get: function get() {
    return _BookmarkSolid.default;
  }
});
Object.defineProperty(exports, "Bookmark", {
  enumerable: true,
  get: function get() {
    return _Bookmark.default;
  }
});
Object.defineProperty(exports, "BriefcaseSolid", {
  enumerable: true,
  get: function get() {
    return _BriefcaseSolid.default;
  }
});
Object.defineProperty(exports, "Briefcase", {
  enumerable: true,
  get: function get() {
    return _Briefcase.default;
  }
});
Object.defineProperty(exports, "Bug", {
  enumerable: true,
  get: function get() {
    return _Bug.default;
  }
});
Object.defineProperty(exports, "Bullhorn", {
  enumerable: true,
  get: function get() {
    return _Bullhorn.default;
  }
});
Object.defineProperty(exports, "Cap", {
  enumerable: true,
  get: function get() {
    return _Cap.default;
  }
});
Object.defineProperty(exports, "CartHeavy", {
  enumerable: true,
  get: function get() {
    return _CartHeavy.default;
  }
});
Object.defineProperty(exports, "CartSolid", {
  enumerable: true,
  get: function get() {
    return _CartSolid.default;
  }
});
Object.defineProperty(exports, "Cart", {
  enumerable: true,
  get: function get() {
    return _Cart.default;
  }
});
Object.defineProperty(exports, "CcSolid", {
  enumerable: true,
  get: function get() {
    return _CcSolid.default;
  }
});
Object.defineProperty(exports, "CertificateAlt", {
  enumerable: true,
  get: function get() {
    return _CertificateAlt.default;
  }
});
Object.defineProperty(exports, "ChartBarCircle", {
  enumerable: true,
  get: function get() {
    return _ChartBarCircle.default;
  }
});
Object.defineProperty(exports, "Check", {
  enumerable: true,
  get: function get() {
    return _Check.default;
  }
});
Object.defineProperty(exports, "ChevronDownHeavy", {
  enumerable: true,
  get: function get() {
    return _ChevronDownHeavy.default;
  }
});
Object.defineProperty(exports, "Chrono", {
  enumerable: true,
  get: function get() {
    return _Chrono.default;
  }
});
Object.defineProperty(exports, "Clipboard", {
  enumerable: true,
  get: function get() {
    return _Clipboard.default;
  }
});
Object.defineProperty(exports, "CloseHeavy", {
  enumerable: true,
  get: function get() {
    return _CloseHeavy.default;
  }
});
Object.defineProperty(exports, "Close", {
  enumerable: true,
  get: function get() {
    return _Close.default;
  }
});
Object.defineProperty(exports, "CloudSolid", {
  enumerable: true,
  get: function get() {
    return _CloudSolid.default;
  }
});
Object.defineProperty(exports, "CloudUpload", {
  enumerable: true,
  get: function get() {
    return _CloudUpload.default;
  }
});
Object.defineProperty(exports, "Cloud", {
  enumerable: true,
  get: function get() {
    return _Cloud.default;
  }
});
Object.defineProperty(exports, "Code", {
  enumerable: true,
  get: function get() {
    return _Code.default;
  }
});
Object.defineProperty(exports, "CommentAlt", {
  enumerable: true,
  get: function get() {
    return _CommentAlt.default;
  }
});
Object.defineProperty(exports, "CommentDots", {
  enumerable: true,
  get: function get() {
    return _CommentDots.default;
  }
});
Object.defineProperty(exports, "CommentSolid", {
  enumerable: true,
  get: function get() {
    return _CommentSolid.default;
  }
});
Object.defineProperty(exports, "Comments", {
  enumerable: true,
  get: function get() {
    return _Comments.default;
  }
});
Object.defineProperty(exports, "Comprass", {
  enumerable: true,
  get: function get() {
    return _Comprass.default;
  }
});
Object.defineProperty(exports, "Compress", {
  enumerable: true,
  get: function get() {
    return _Compress.default;
  }
});
Object.defineProperty(exports, "DownloadDoc", {
  enumerable: true,
  get: function get() {
    return _DownloadDoc.default;
  }
});
Object.defineProperty(exports, "Edit", {
  enumerable: true,
  get: function get() {
    return _Edit.default;
  }
});
Object.defineProperty(exports, "ElipsisHeavy", {
  enumerable: true,
  get: function get() {
    return _ElipsisHeavy.default;
  }
});
Object.defineProperty(exports, "Ellipsis", {
  enumerable: true,
  get: function get() {
    return _Ellipsis.default;
  }
});
Object.defineProperty(exports, "EnvelopeSolid", {
  enumerable: true,
  get: function get() {
    return _EnvelopeSolid.default;
  }
});
Object.defineProperty(exports, "Envelope", {
  enumerable: true,
  get: function get() {
    return _Envelope.default;
  }
});
Object.defineProperty(exports, "Event", {
  enumerable: true,
  get: function get() {
    return _Event.default;
  }
});
Object.defineProperty(exports, "ExclamationCircleSolid", {
  enumerable: true,
  get: function get() {
    return _ExclamationCircleSolid.default;
  }
});
Object.defineProperty(exports, "ExclamationCircle", {
  enumerable: true,
  get: function get() {
    return _ExclamationCircle.default;
  }
});
Object.defineProperty(exports, "ExclamationSolid", {
  enumerable: true,
  get: function get() {
    return _ExclamationSolid.default;
  }
});
Object.defineProperty(exports, "EyeSlash", {
  enumerable: true,
  get: function get() {
    return _EyeSlash.default;
  }
});
Object.defineProperty(exports, "EyeSolid", {
  enumerable: true,
  get: function get() {
    return _EyeSolid.default;
  }
});
Object.defineProperty(exports, "FacebookAlt", {
  enumerable: true,
  get: function get() {
    return _FacebookAlt.default;
  }
});
Object.defineProperty(exports, "FacebookMin", {
  enumerable: true,
  get: function get() {
    return _FacebookMin.default;
  }
});
Object.defineProperty(exports, "Facebook", {
  enumerable: true,
  get: function get() {
    return _Facebook.default;
  }
});
Object.defineProperty(exports, "FileAlt", {
  enumerable: true,
  get: function get() {
    return _FileAlt.default;
  }
});
Object.defineProperty(exports, "Flag", {
  enumerable: true,
  get: function get() {
    return _Flag.default;
  }
});
Object.defineProperty(exports, "FontHeavy", {
  enumerable: true,
  get: function get() {
    return _FontHeavy.default;
  }
});
Object.defineProperty(exports, "Font", {
  enumerable: true,
  get: function get() {
    return _Font.default;
  }
});
Object.defineProperty(exports, "GiftCardSolid", {
  enumerable: true,
  get: function get() {
    return _GiftCardSolid.default;
  }
});
Object.defineProperty(exports, "GiftStep1", {
  enumerable: true,
  get: function get() {
    return _GiftStep.default;
  }
});
Object.defineProperty(exports, "GiftStep2", {
  enumerable: true,
  get: function get() {
    return _GiftStep2.default;
  }
});
Object.defineProperty(exports, "GiftStep3", {
  enumerable: true,
  get: function get() {
    return _GiftStep3.default;
  }
});
Object.defineProperty(exports, "Github", {
  enumerable: true,
  get: function get() {
    return _Github.default;
  }
});
Object.defineProperty(exports, "GlobeSolid", {
  enumerable: true,
  get: function get() {
    return _GlobeSolid.default;
  }
});
Object.defineProperty(exports, "Globe", {
  enumerable: true,
  get: function get() {
    return _Globe.default;
  }
});
Object.defineProperty(exports, "Gmail", {
  enumerable: true,
  get: function get() {
    return _Gmail.default;
  }
});
Object.defineProperty(exports, "GridIcon", {
  enumerable: true,
  get: function get() {
    return _GridIcon.default;
  }
});
Object.defineProperty(exports, "GridSolid", {
  enumerable: true,
  get: function get() {
    return _GridSolid.default;
  }
});
Object.defineProperty(exports, "Heading", {
  enumerable: true,
  get: function get() {
    return _Heading.default;
  }
});
Object.defineProperty(exports, "HeartSolid", {
  enumerable: true,
  get: function get() {
    return _HeartSolid.default;
  }
});
Object.defineProperty(exports, "ImageHeavy", {
  enumerable: true,
  get: function get() {
    return _ImageHeavy.default;
  }
});
Object.defineProperty(exports, "Image", {
  enumerable: true,
  get: function get() {
    return _Image.default;
  }
});
Object.defineProperty(exports, "InfoCircle", {
  enumerable: true,
  get: function get() {
    return _InfoCircle.default;
  }
});
Object.defineProperty(exports, "InfoSolid", {
  enumerable: true,
  get: function get() {
    return _InfoSolid.default;
  }
});
Object.defineProperty(exports, "Instagram", {
  enumerable: true,
  get: function get() {
    return _Instagram.default;
  }
});
Object.defineProperty(exports, "Italic", {
  enumerable: true,
  get: function get() {
    return _Italic.default;
  }
});
Object.defineProperty(exports, "Knot", {
  enumerable: true,
  get: function get() {
    return _Knot.default;
  }
});
Object.defineProperty(exports, "Layers", {
  enumerable: true,
  get: function get() {
    return _Layers.default;
  }
});
Object.defineProperty(exports, "LinkIcon", {
  enumerable: true,
  get: function get() {
    return _LinkIcon.default;
  }
});
Object.defineProperty(exports, "LinkedinMin", {
  enumerable: true,
  get: function get() {
    return _LinkedinMin.default;
  }
});
Object.defineProperty(exports, "Linkedin", {
  enumerable: true,
  get: function get() {
    return _Linkedin.default;
  }
});
Object.defineProperty(exports, "ListUl", {
  enumerable: true,
  get: function get() {
    return _ListUl.default;
  }
});
Object.defineProperty(exports, "List", {
  enumerable: true,
  get: function get() {
    return _List.default;
  }
});
Object.defineProperty(exports, "Live", {
  enumerable: true,
  get: function get() {
    return _Live.default;
  }
});
Object.defineProperty(exports, "MailCircle", {
  enumerable: true,
  get: function get() {
    return _MailCircle.default;
  }
});
Object.defineProperty(exports, "MapMarker", {
  enumerable: true,
  get: function get() {
    return _MapMarker.default;
  }
});
Object.defineProperty(exports, "MenuHeavy", {
  enumerable: true,
  get: function get() {
    return _MenuHeavy.default;
  }
});
Object.defineProperty(exports, "MessageHeavy", {
  enumerable: true,
  get: function get() {
    return _MessageHeavy.default;
  }
});
Object.defineProperty(exports, "Minus", {
  enumerable: true,
  get: function get() {
    return _Minus.default;
  }
});
Object.defineProperty(exports, "Outlook", {
  enumerable: true,
  get: function get() {
    return _Outlook.default;
  }
});
Object.defineProperty(exports, "PayPal", {
  enumerable: true,
  get: function get() {
    return _PayPal.default;
  }
});
Object.defineProperty(exports, "Payu", {
  enumerable: true,
  get: function get() {
    return _Payu.default;
  }
});
Object.defineProperty(exports, "PencilAlt", {
  enumerable: true,
  get: function get() {
    return _PencilAlt.default;
  }
});
Object.defineProperty(exports, "Pin", {
  enumerable: true,
  get: function get() {
    return _Pin.default;
  }
});
Object.defineProperty(exports, "Pinterest", {
  enumerable: true,
  get: function get() {
    return _Pinterest.default;
  }
});
Object.defineProperty(exports, "PipIcon", {
  enumerable: true,
  get: function get() {
    return _PipIcon.default;
  }
});
Object.defineProperty(exports, "PlayCircleHeavy", {
  enumerable: true,
  get: function get() {
    return _PlayCircleHeavy.default;
  }
});
Object.defineProperty(exports, "PlayCircleSolid", {
  enumerable: true,
  get: function get() {
    return _PlayCircleSolid.default;
  }
});
Object.defineProperty(exports, "PlaySolid", {
  enumerable: true,
  get: function get() {
    return _PlaySolid.default;
  }
});
Object.defineProperty(exports, "PlusCircle", {
  enumerable: true,
  get: function get() {
    return _PlusCircle.default;
  }
});
Object.defineProperty(exports, "Printer", {
  enumerable: true,
  get: function get() {
    return _Printer.default;
  }
});
Object.defineProperty(exports, "QuestionCircleSolid", {
  enumerable: true,
  get: function get() {
    return _QuestionCircleSolid.default;
  }
});
Object.defineProperty(exports, "QuestionCircle", {
  enumerable: true,
  get: function get() {
    return _QuestionCircle.default;
  }
});
Object.defineProperty(exports, "QuestionSolid", {
  enumerable: true,
  get: function get() {
    return _QuestionSolid.default;
  }
});
Object.defineProperty(exports, "QuoteSolid", {
  enumerable: true,
  get: function get() {
    return _QuoteSolid.default;
  }
});
Object.defineProperty(exports, "Rss", {
  enumerable: true,
  get: function get() {
    return _Rss.default;
  }
});
Object.defineProperty(exports, "SearchBigHeavy", {
  enumerable: true,
  get: function get() {
    return _SearchBigHeavy.default;
  }
});
Object.defineProperty(exports, "SearchHeavy", {
  enumerable: true,
  get: function get() {
    return _SearchHeavy.default;
  }
});
Object.defineProperty(exports, "Search", {
  enumerable: true,
  get: function get() {
    return _Search.default;
  }
});
Object.defineProperty(exports, "Send", {
  enumerable: true,
  get: function get() {
    return _Send.default;
  }
});
Object.defineProperty(exports, "SortSolid", {
  enumerable: true,
  get: function get() {
    return _SortSolid.default;
  }
});
Object.defineProperty(exports, "Sort", {
  enumerable: true,
  get: function get() {
    return _Sort.default;
  }
});
Object.defineProperty(exports, "Spinner", {
  enumerable: true,
  get: function get() {
    return _Spinner.default;
  }
});
Object.defineProperty(exports, "StarCircle", {
  enumerable: true,
  get: function get() {
    return _StarCircle.default;
  }
});
Object.defineProperty(exports, "StarSolid", {
  enumerable: true,
  get: function get() {
    return _StarSolid.default;
  }
});
Object.defineProperty(exports, "Star", {
  enumerable: true,
  get: function get() {
    return _Star.default;
  }
});
Object.defineProperty(exports, "StepForwardSolid", {
  enumerable: true,
  get: function get() {
    return _StepForwardSolid.default;
  }
});
Object.defineProperty(exports, "StepForward", {
  enumerable: true,
  get: function get() {
    return _StepForward.default;
  }
});
Object.defineProperty(exports, "Tag", {
  enumerable: true,
  get: function get() {
    return _Tag.default;
  }
});
Object.defineProperty(exports, "Tasks", {
  enumerable: true,
  get: function get() {
    return _Tasks.default;
  }
});
Object.defineProperty(exports, "ThumbsUp", {
  enumerable: true,
  get: function get() {
    return _ThumbsUp.default;
  }
});
Object.defineProperty(exports, "TicketSolid", {
  enumerable: true,
  get: function get() {
    return _TicketSolid.default;
  }
});
Object.defineProperty(exports, "Ticket", {
  enumerable: true,
  get: function get() {
    return _Ticket.default;
  }
});
Object.defineProperty(exports, "TildeSolid", {
  enumerable: true,
  get: function get() {
    return _TildeSolid.default;
  }
});
Object.defineProperty(exports, "TildeCircleSolid", {
  enumerable: true,
  get: function get() {
    return _TildeCircleSolid.default;
  }
});
Object.defineProperty(exports, "Tilde", {
  enumerable: true,
  get: function get() {
    return _Tilde.default;
  }
});
Object.defineProperty(exports, "Twitter", {
  enumerable: true,
  get: function get() {
    return _Twitter.default;
  }
});
Object.defineProperty(exports, "UserOkSolid", {
  enumerable: true,
  get: function get() {
    return _UserOkSolid.default;
  }
});
Object.defineProperty(exports, "UserPlus", {
  enumerable: true,
  get: function get() {
    return _UserPlus.default;
  }
});
Object.defineProperty(exports, "UserSolid", {
  enumerable: true,
  get: function get() {
    return _UserSolid.default;
  }
});
Object.defineProperty(exports, "Users", {
  enumerable: true,
  get: function get() {
    return _Users.default;
  }
});
Object.defineProperty(exports, "Vimeo", {
  enumerable: true,
  get: function get() {
    return _Vimeo.default;
  }
});
Object.defineProperty(exports, "Whatsapp", {
  enumerable: true,
  get: function get() {
    return _Whatsapp.default;
  }
});
Object.defineProperty(exports, "Yahoo", {
  enumerable: true,
  get: function get() {
    return _Yahoo.default;
  }
});
Object.defineProperty(exports, "Youtube", {
  enumerable: true,
  get: function get() {
    return _Youtube.default;
  }
});
Object.defineProperty(exports, "Arrows", {
  enumerable: true,
  get: function get() {
    return _Arrows.default;
  }
});
Object.defineProperty(exports, "Backward", {
  enumerable: true,
  get: function get() {
    return _Backward.default;
  }
});
Object.defineProperty(exports, "BookmarkCircle", {
  enumerable: true,
  get: function get() {
    return _BookmarkCircle.default;
  }
});
Object.defineProperty(exports, "BookmarkStarCircle", {
  enumerable: true,
  get: function get() {
    return _BookmarkStarCircle.default;
  }
});
Object.defineProperty(exports, "BullhornCircle", {
  enumerable: true,
  get: function get() {
    return _BullhornCircle.default;
  }
});
Object.defineProperty(exports, "Calendar", {
  enumerable: true,
  get: function get() {
    return _Calendar.default;
  }
});
Object.defineProperty(exports, "CameraMovie", {
  enumerable: true,
  get: function get() {
    return _CameraMovie.default;
  }
});
Object.defineProperty(exports, "Camera", {
  enumerable: true,
  get: function get() {
    return _Camera.default;
  }
});
Object.defineProperty(exports, "CameraSlash", {
  enumerable: true,
  get: function get() {
    return _CameraSlash.default;
  }
});
Object.defineProperty(exports, "Cc", {
  enumerable: true,
  get: function get() {
    return _Cc.default;
  }
});
Object.defineProperty(exports, "CertificateCircle", {
  enumerable: true,
  get: function get() {
    return _CertificateCircle.default;
  }
});
Object.defineProperty(exports, "Certificate", {
  enumerable: true,
  get: function get() {
    return _Certificate.default;
  }
});
Object.defineProperty(exports, "ChartBar", {
  enumerable: true,
  get: function get() {
    return _ChartBar.default;
  }
});
Object.defineProperty(exports, "CheckCircle", {
  enumerable: true,
  get: function get() {
    return _CheckCircle.default;
  }
});
Object.defineProperty(exports, "ChevronDown", {
  enumerable: true,
  get: function get() {
    return _ChevronDown.default;
  }
});
Object.defineProperty(exports, "ChevronLeft", {
  enumerable: true,
  get: function get() {
    return _ChevronLeft.default;
  }
});
Object.defineProperty(exports, "ChevronRight", {
  enumerable: true,
  get: function get() {
    return _ChevronRight.default;
  }
});
Object.defineProperty(exports, "ChevronUp", {
  enumerable: true,
  get: function get() {
    return _ChevronUp.default;
  }
});
Object.defineProperty(exports, "Clock", {
  enumerable: true,
  get: function get() {
    return _Clock.default;
  }
});
Object.defineProperty(exports, "Cog", {
  enumerable: true,
  get: function get() {
    return _Cog.default;
  }
});
Object.defineProperty(exports, "Comment", {
  enumerable: true,
  get: function get() {
    return _Comment.default;
  }
});
Object.defineProperty(exports, "Computer", {
  enumerable: true,
  get: function get() {
    return _Computer.default;
  }
});
Object.defineProperty(exports, "Eye", {
  enumerable: true,
  get: function get() {
    return _Eye.default;
  }
});
Object.defineProperty(exports, "File", {
  enumerable: true,
  get: function get() {
    return _File.default;
  }
});
Object.defineProperty(exports, "Film", {
  enumerable: true,
  get: function get() {
    return _Film.default;
  }
});
Object.defineProperty(exports, "Forward", {
  enumerable: true,
  get: function get() {
    return _Forward.default;
  }
});
Object.defineProperty(exports, "GiftBag", {
  enumerable: true,
  get: function get() {
    return _GiftBag.default;
  }
});
Object.defineProperty(exports, "Gift", {
  enumerable: true,
  get: function get() {
    return _Gift.default;
  }
});
Object.defineProperty(exports, "Heart", {
  enumerable: true,
  get: function get() {
    return _Heart.default;
  }
});
Object.defineProperty(exports, "Infinite", {
  enumerable: true,
  get: function get() {
    return _Infinite.default;
  }
});
Object.defineProperty(exports, "Lectern", {
  enumerable: true,
  get: function get() {
    return _Lectern.default;
  }
});
Object.defineProperty(exports, "Lightbulb", {
  enumerable: true,
  get: function get() {
    return _Lightbulb.default;
  }
});
Object.defineProperty(exports, "ListAltCircle", {
  enumerable: true,
  get: function get() {
    return _ListAltCircle.default;
  }
});
Object.defineProperty(exports, "Lock", {
  enumerable: true,
  get: function get() {
    return _Lock.default;
  }
});
Object.defineProperty(exports, "LogOut", {
  enumerable: true,
  get: function get() {
    return _LogOut.default;
  }
});
Object.defineProperty(exports, "Mobile", {
  enumerable: true,
  get: function get() {
    return _Mobile.default;
  }
});
Object.defineProperty(exports, "MoneyCircle", {
  enumerable: true,
  get: function get() {
    return _MoneyCircle.default;
  }
});
Object.defineProperty(exports, "OpenCircle", {
  enumerable: true,
  get: function get() {
    return _OpenCircle.default;
  }
});
Object.defineProperty(exports, "OrgAccessCircle", {
  enumerable: true,
  get: function get() {
    return _OrgAccessCircle.default;
  }
});
Object.defineProperty(exports, "Pencil", {
  enumerable: true,
  get: function get() {
    return _Pencil.default;
  }
});
Object.defineProperty(exports, "PercentageCircle", {
  enumerable: true,
  get: function get() {
    return _PercentageCircle.default;
  }
});
Object.defineProperty(exports, "Plus", {
  enumerable: true,
  get: function get() {
    return _Plus.default;
  }
});
Object.defineProperty(exports, "ProCircle", {
  enumerable: true,
  get: function get() {
    return _ProCircle.default;
  }
});
Object.defineProperty(exports, "Share", {
  enumerable: true,
  get: function get() {
    return _Share.default;
  }
});
Object.defineProperty(exports, "Smile", {
  enumerable: true,
  get: function get() {
    return _Smile.default;
  }
});
Object.defineProperty(exports, "Storm", {
  enumerable: true,
  get: function get() {
    return _Storm.default;
  }
});
Object.defineProperty(exports, "Sync", {
  enumerable: true,
  get: function get() {
    return _Sync.default;
  }
});
Object.defineProperty(exports, "ThumbsDown", {
  enumerable: true,
  get: function get() {
    return _ThumbsDown.default;
  }
});
Object.defineProperty(exports, "TildeCircle", {
  enumerable: true,
  get: function get() {
    return _TildeCircle.default;
  }
});
Object.defineProperty(exports, "Trash", {
  enumerable: true,
  get: function get() {
    return _Trash.default;
  }
});
Object.defineProperty(exports, "Trophy", {
  enumerable: true,
  get: function get() {
    return _Trophy.default;
  }
});
Object.defineProperty(exports, "UserBookmarkCircle", {
  enumerable: true,
  get: function get() {
    return _UserBookmarkCircle.default;
  }
});
Object.defineProperty(exports, "UserBookmark", {
  enumerable: true,
  get: function get() {
    return _UserBookmark.default;
  }
});
Object.defineProperty(exports, "UserCheckCircle", {
  enumerable: true,
  get: function get() {
    return _UserCheckCircle.default;
  }
});
Object.defineProperty(exports, "UserOk", {
  enumerable: true,
  get: function get() {
    return _UserOk.default;
  }
});
Object.defineProperty(exports, "User", {
  enumerable: true,
  get: function get() {
    return _User.default;
  }
});
Object.defineProperty(exports, "UsersCircle", {
  enumerable: true,
  get: function get() {
    return _UsersCircle.default;
  }
});
Object.defineProperty(exports, "UsersLight", {
  enumerable: true,
  get: function get() {
    return _UsersLight.default;
  }
});
Object.defineProperty(exports, "UsersNew", {
  enumerable: true,
  get: function get() {
    return _UsersNew.default;
  }
});
Object.defineProperty(exports, "UsersShare", {
  enumerable: true,
  get: function get() {
    return _UsersShare.default;
  }
});
Object.defineProperty(exports, "Volume", {
  enumerable: true,
  get: function get() {
    return _Volume.default;
  }
});

var _AddHeavy = _interopRequireDefault(require("./AddHeavy"));

var _Apple = _interopRequireDefault(require("./Apple"));

var _Arrange = _interopRequireDefault(require("./Arrange"));

var _ArrowCircleDown = _interopRequireDefault(require("./ArrowCircleDown"));

var _ArrowCircleLeft = _interopRequireDefault(require("./ArrowCircleLeft"));

var _ArrowCircleRight = _interopRequireDefault(require("./ArrowCircleRight"));

var _ArrowCircleSide = _interopRequireDefault(require("./ArrowCircleSide"));

var _ArrowCircleUp = _interopRequireDefault(require("./ArrowCircleUp"));

var _ArrowDown = _interopRequireDefault(require("./ArrowDown"));

var _ArrowLeft = _interopRequireDefault(require("./ArrowLeft"));

var _ArrowRight = _interopRequireDefault(require("./ArrowRight"));

var _ArrowUp = _interopRequireDefault(require("./ArrowUp"));

var _Asterisk = _interopRequireDefault(require("./Asterisk"));

var _Ban = _interopRequireDefault(require("./Ban"));

var _BellHeavy = _interopRequireDefault(require("./BellHeavy"));

var _Bell = _interopRequireDefault(require("./Bell"));

var _Bold = _interopRequireDefault(require("./Bold"));

var _BookmarkCircleSolid = _interopRequireDefault(require("./BookmarkCircleSolid"));

var _BookmarkSolid = _interopRequireDefault(require("./BookmarkSolid"));

var _Bookmark = _interopRequireDefault(require("./Bookmark"));

var _BriefcaseSolid = _interopRequireDefault(require("./BriefcaseSolid"));

var _Briefcase = _interopRequireDefault(require("./Briefcase"));

var _Bug = _interopRequireDefault(require("./Bug"));

var _Bullhorn = _interopRequireDefault(require("./Bullhorn"));

var _Cap = _interopRequireDefault(require("./Cap"));

var _CartHeavy = _interopRequireDefault(require("./CartHeavy"));

var _CartSolid = _interopRequireDefault(require("./CartSolid"));

var _Cart = _interopRequireDefault(require("./Cart"));

var _CcSolid = _interopRequireDefault(require("./CcSolid"));

var _CertificateAlt = _interopRequireDefault(require("./CertificateAlt"));

var _ChartBarCircle = _interopRequireDefault(require("./ChartBarCircle"));

var _Check = _interopRequireDefault(require("./Check"));

var _ChevronDownHeavy = _interopRequireDefault(require("./ChevronDownHeavy"));

var _Chrono = _interopRequireDefault(require("./Chrono"));

var _Clipboard = _interopRequireDefault(require("./Clipboard"));

var _CloseHeavy = _interopRequireDefault(require("./CloseHeavy"));

var _Close = _interopRequireDefault(require("./Close"));

var _CloudSolid = _interopRequireDefault(require("./CloudSolid"));

var _CloudUpload = _interopRequireDefault(require("./CloudUpload"));

var _Cloud = _interopRequireDefault(require("./Cloud"));

var _Code = _interopRequireDefault(require("./Code"));

var _CommentAlt = _interopRequireDefault(require("./CommentAlt"));

var _CommentDots = _interopRequireDefault(require("./CommentDots"));

var _CommentSolid = _interopRequireDefault(require("./CommentSolid"));

var _Comments = _interopRequireDefault(require("./Comments"));

var _Comprass = _interopRequireDefault(require("./Comprass"));

var _Compress = _interopRequireDefault(require("./Compress"));

var _DownloadDoc = _interopRequireDefault(require("./DownloadDoc"));

var _Edit = _interopRequireDefault(require("./Edit"));

var _ElipsisHeavy = _interopRequireDefault(require("./ElipsisHeavy"));

var _Ellipsis = _interopRequireDefault(require("./Ellipsis"));

var _EnvelopeSolid = _interopRequireDefault(require("./EnvelopeSolid"));

var _Envelope = _interopRequireDefault(require("./Envelope"));

var _Event = _interopRequireDefault(require("./Event"));

var _ExclamationCircleSolid = _interopRequireDefault(require("./ExclamationCircleSolid"));

var _ExclamationCircle = _interopRequireDefault(require("./ExclamationCircle"));

var _ExclamationSolid = _interopRequireDefault(require("./ExclamationSolid"));

var _EyeSlash = _interopRequireDefault(require("./EyeSlash"));

var _EyeSolid = _interopRequireDefault(require("./EyeSolid"));

var _FacebookAlt = _interopRequireDefault(require("./FacebookAlt"));

var _FacebookMin = _interopRequireDefault(require("./FacebookMin"));

var _Facebook = _interopRequireDefault(require("./Facebook"));

var _FileAlt = _interopRequireDefault(require("./FileAlt"));

var _Flag = _interopRequireDefault(require("./Flag"));

var _FontHeavy = _interopRequireDefault(require("./FontHeavy"));

var _Font = _interopRequireDefault(require("./Font"));

var _GiftCardSolid = _interopRequireDefault(require("./GiftCardSolid"));

var _GiftStep = _interopRequireDefault(require("./GiftStep1"));

var _GiftStep2 = _interopRequireDefault(require("./GiftStep2"));

var _GiftStep3 = _interopRequireDefault(require("./GiftStep3"));

var _Github = _interopRequireDefault(require("./Github"));

var _GlobeSolid = _interopRequireDefault(require("./GlobeSolid"));

var _Globe = _interopRequireDefault(require("./Globe"));

var _Gmail = _interopRequireDefault(require("./Gmail"));

var _GridIcon = _interopRequireDefault(require("./GridIcon"));

var _GridSolid = _interopRequireDefault(require("./GridSolid"));

var _Heading = _interopRequireDefault(require("./Heading"));

var _HeartSolid = _interopRequireDefault(require("./HeartSolid"));

var _ImageHeavy = _interopRequireDefault(require("./ImageHeavy"));

var _Image = _interopRequireDefault(require("./Image"));

var _InfoCircle = _interopRequireDefault(require("./InfoCircle"));

var _InfoSolid = _interopRequireDefault(require("./InfoSolid"));

var _Instagram = _interopRequireDefault(require("./Instagram"));

var _Italic = _interopRequireDefault(require("./Italic"));

var _Knot = _interopRequireDefault(require("./Knot"));

var _Layers = _interopRequireDefault(require("./Layers"));

var _LinkIcon = _interopRequireDefault(require("./LinkIcon"));

var _LinkedinMin = _interopRequireDefault(require("./LinkedinMin"));

var _Linkedin = _interopRequireDefault(require("./Linkedin"));

var _ListUl = _interopRequireDefault(require("./ListUl"));

var _List = _interopRequireDefault(require("./List"));

var _Live = _interopRequireDefault(require("./Live"));

var _MailCircle = _interopRequireDefault(require("./MailCircle"));

var _MapMarker = _interopRequireDefault(require("./MapMarker"));

var _MenuHeavy = _interopRequireDefault(require("./MenuHeavy"));

var _MessageHeavy = _interopRequireDefault(require("./MessageHeavy"));

var _Minus = _interopRequireDefault(require("./Minus"));

var _Outlook = _interopRequireDefault(require("./Outlook"));

var _PayPal = _interopRequireDefault(require("./PayPal"));

var _Payu = _interopRequireDefault(require("./Payu"));

var _PencilAlt = _interopRequireDefault(require("./PencilAlt"));

var _Pin = _interopRequireDefault(require("./Pin"));

var _Pinterest = _interopRequireDefault(require("./Pinterest"));

var _PipIcon = _interopRequireDefault(require("./PipIcon"));

var _PlayCircleHeavy = _interopRequireDefault(require("./PlayCircleHeavy"));

var _PlayCircleSolid = _interopRequireDefault(require("./PlayCircleSolid"));

var _PlaySolid = _interopRequireDefault(require("./PlaySolid"));

var _PlusCircle = _interopRequireDefault(require("./PlusCircle"));

var _Printer = _interopRequireDefault(require("./Printer"));

var _QuestionCircleSolid = _interopRequireDefault(require("./QuestionCircleSolid"));

var _QuestionCircle = _interopRequireDefault(require("./QuestionCircle"));

var _QuestionSolid = _interopRequireDefault(require("./QuestionSolid"));

var _QuoteSolid = _interopRequireDefault(require("./QuoteSolid"));

var _Rss = _interopRequireDefault(require("./Rss"));

var _SearchBigHeavy = _interopRequireDefault(require("./SearchBigHeavy"));

var _SearchHeavy = _interopRequireDefault(require("./SearchHeavy"));

var _Search = _interopRequireDefault(require("./Search"));

var _Send = _interopRequireDefault(require("./Send"));

var _SortSolid = _interopRequireDefault(require("./SortSolid"));

var _Sort = _interopRequireDefault(require("./Sort"));

var _Spinner = _interopRequireDefault(require("./Spinner"));

var _StarCircle = _interopRequireDefault(require("./StarCircle"));

var _StarSolid = _interopRequireDefault(require("./StarSolid"));

var _Star = _interopRequireDefault(require("./Star"));

var _StepForwardSolid = _interopRequireDefault(require("./StepForwardSolid"));

var _StepForward = _interopRequireDefault(require("./StepForward"));

var _Tag = _interopRequireDefault(require("./Tag"));

var _Tasks = _interopRequireDefault(require("./Tasks"));

var _ThumbsUp = _interopRequireDefault(require("./ThumbsUp"));

var _TicketSolid = _interopRequireDefault(require("./TicketSolid"));

var _Ticket = _interopRequireDefault(require("./Ticket"));

var _TildeSolid = _interopRequireDefault(require("./TildeSolid"));

var _TildeCircleSolid = _interopRequireDefault(require("./TildeCircleSolid"));

var _Tilde = _interopRequireDefault(require("./Tilde"));

var _Twitter = _interopRequireDefault(require("./Twitter"));

var _UserOkSolid = _interopRequireDefault(require("./UserOkSolid"));

var _UserPlus = _interopRequireDefault(require("./UserPlus"));

var _UserSolid = _interopRequireDefault(require("./UserSolid"));

var _Users = _interopRequireDefault(require("./Users"));

var _Vimeo = _interopRequireDefault(require("./Vimeo"));

var _Whatsapp = _interopRequireDefault(require("./Whatsapp"));

var _Yahoo = _interopRequireDefault(require("./Yahoo"));

var _Youtube = _interopRequireDefault(require("./Youtube"));

var _Arrows = _interopRequireDefault(require("./Arrows"));

var _Backward = _interopRequireDefault(require("./Backward"));

var _BookmarkCircle = _interopRequireDefault(require("./BookmarkCircle"));

var _BookmarkStarCircle = _interopRequireDefault(require("./BookmarkStarCircle"));

var _BullhornCircle = _interopRequireDefault(require("./BullhornCircle"));

var _Calendar = _interopRequireDefault(require("./Calendar"));

var _CameraMovie = _interopRequireDefault(require("./CameraMovie"));

var _Camera = _interopRequireDefault(require("./Camera"));

var _CameraSlash = _interopRequireDefault(require("./CameraSlash"));

var _Cc = _interopRequireDefault(require("./Cc"));

var _CertificateCircle = _interopRequireDefault(require("./CertificateCircle"));

var _Certificate = _interopRequireDefault(require("./Certificate"));

var _ChartBar = _interopRequireDefault(require("./ChartBar"));

var _CheckCircle = _interopRequireDefault(require("./CheckCircle"));

var _ChevronDown = _interopRequireDefault(require("./ChevronDown"));

var _ChevronLeft = _interopRequireDefault(require("./ChevronLeft"));

var _ChevronRight = _interopRequireDefault(require("./ChevronRight"));

var _ChevronUp = _interopRequireDefault(require("./ChevronUp"));

var _Clock = _interopRequireDefault(require("./Clock"));

var _Cog = _interopRequireDefault(require("./Cog"));

var _Comment = _interopRequireDefault(require("./Comment"));

var _Computer = _interopRequireDefault(require("./Computer"));

var _Eye = _interopRequireDefault(require("./Eye"));

var _File = _interopRequireDefault(require("./File"));

var _Film = _interopRequireDefault(require("./Film"));

var _Forward = _interopRequireDefault(require("./Forward"));

var _GiftBag = _interopRequireDefault(require("./GiftBag"));

var _Gift = _interopRequireDefault(require("./Gift"));

var _Heart = _interopRequireDefault(require("./Heart"));

var _Infinite = _interopRequireDefault(require("./Infinite"));

var _Lectern = _interopRequireDefault(require("./Lectern"));

var _Lightbulb = _interopRequireDefault(require("./Lightbulb"));

var _ListAltCircle = _interopRequireDefault(require("./ListAltCircle"));

var _Lock = _interopRequireDefault(require("./Lock"));

var _LogOut = _interopRequireDefault(require("./LogOut"));

var _Mobile = _interopRequireDefault(require("./Mobile"));

var _MoneyCircle = _interopRequireDefault(require("./MoneyCircle"));

var _OpenCircle = _interopRequireDefault(require("./OpenCircle"));

var _OrgAccessCircle = _interopRequireDefault(require("./OrgAccessCircle"));

var _Pencil = _interopRequireDefault(require("./Pencil"));

var _PercentageCircle = _interopRequireDefault(require("./PercentageCircle"));

var _Plus = _interopRequireDefault(require("./Plus"));

var _ProCircle = _interopRequireDefault(require("./ProCircle"));

var _Share = _interopRequireDefault(require("./Share"));

var _Smile = _interopRequireDefault(require("./Smile"));

var _Storm = _interopRequireDefault(require("./Storm"));

var _Sync = _interopRequireDefault(require("./Sync"));

var _ThumbsDown = _interopRequireDefault(require("./ThumbsDown"));

var _TildeCircle = _interopRequireDefault(require("./TildeCircle"));

var _Trash = _interopRequireDefault(require("./Trash"));

var _Trophy = _interopRequireDefault(require("./Trophy"));

var _UserBookmarkCircle = _interopRequireDefault(require("./UserBookmarkCircle"));

var _UserBookmark = _interopRequireDefault(require("./UserBookmark"));

var _UserCheckCircle = _interopRequireDefault(require("./UserCheckCircle"));

var _UserOk = _interopRequireDefault(require("./UserOk"));

var _User = _interopRequireDefault(require("./User"));

var _UsersCircle = _interopRequireDefault(require("./UsersCircle"));

var _UsersLight = _interopRequireDefault(require("./UsersLight"));

var _UsersNew = _interopRequireDefault(require("./UsersNew"));

var _UsersShare = _interopRequireDefault(require("./UsersShare"));

var _Volume = _interopRequireDefault(require("./Volume"));